import React from "react";
import Header from "../HeaderOne/Main";
import Footer from "../FooterOne/Main";
import PageHeaderTwo from "../Menblogdtls/Blogdtlsbred";
import BlogDetailPage from "../Menblogdtls/BlogDetailPage";

function Main() {
  return (
    <div>
      <Header />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <div className="page-wrapper-bg-3" />
            <main className="site-main">
              <PageHeaderTwo />
              <BlogDetailPage />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
